import { Trans } from "react-i18next";
import { useState, useEffect } from "react";

/**
 * Connectivity flag for the employee-facing screens: an amber banner and a
 * disabled Submit Vote while offline. Publishing, reviewing and closing are
 * gated on this too.
 */
export function useOnline() {
  const [online, setOnline] = useState(() =>
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
}

/** Amber offline banner shown above employee poll content. */
export function OfflineBanner() {
  return (
    <div className="mb-4 flex items-center gap-2 rounded-xl border border-(--status-warning-dot)/40 bg-(--status-warning-bg) px-4 py-3 text-sm font-semibold text-(--status-warning-fg)">
      <span aria-hidden="true">⚠</span>
      <Trans i18nKey="polls.youReOfflinePollsYouAlreadyOpenedStay" />
    </div>
  );
}
